export default __webpack_public_path__ + "static/media/el-arq-hexagonal.1b542169.png";